import { render, staticRenderFns } from "./DiscussionDownloadList.vue?vue&type=template&id=31c2b6dc&scoped=true"
import script from "./DiscussionDownloadList.vue?vue&type=script&lang=js"
export * from "./DiscussionDownloadList.vue?vue&type=script&lang=js"
import style0 from "./DiscussionDownloadList.vue?vue&type=style&index=0&id=31c2b6dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c2b6dc",
  null
  
)

export default component.exports